import { makeStyles } from "@material-ui/core";

export const mentionStyle = makeStyles((theme) => {
    return {
      '@global': {
        '.DraftEditor-root': { width: '100%', fontSize: '1.5rem' },
        '.public-DraftEditor-content': (props) => props.multiline ? { padding: theme.spacing(2, 2) } : {},
        '.public-DraftEditorPlaceholder-root': { margin: '16px auto auto 15px' }
      },
      mention: {
        color: '#575f67',
        cursor: 'pointer',
        display: 'inline-block',
        background: '#e6f3ff',
        paddingLeft: '2px',
        paddingRight: '2px',
        borderRadius: '2px',
        textDecoration: 'none',
        '&:hover, &:focus': {
          color: '#677584',
          background: '#edf5fd',
          outline: '0',
        },
        '&:active': {
          color: '#222',
          background: '#455261',
        },
      },
      mentionSuggestions: {
        border: '1px solid #eee',
        position: 'absolute !important',
        minWidth: '220px',
        maxWidth: '440px',
        maxHeight: '250px',
        height: 'auto !important',
        overflowY: 'scroll',
        background: theme.palette.mode === 'dark' ? theme.palette.common.black : theme.palette.common.white,
        color: theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.common.black,
        borderRadius: '2px',
        cursor: 'pointer',
        paddingTop: '8px',
        paddingBottom: '8px',
        zIndex: 20,
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        transform: 'scale(0)',
        textAlign: 'left',
      },
      mentionSuggestionsEntry: {
        padding: '7px 10px 3px 10px',
        transition: 'background-color 0.4s cubic-bezier(.27, 1.27, .48, .56)',
        '&:active': { backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#cce7ff' },
      },
      mentionSuggestionsEntryFocused: {
        padding: '7px 10px 3px 10px',
        transition: 'background-color 0.4s cubic-bezier(.27, 1.27, .48, .56)',
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#e6f3ff',
        '&:active': { backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#cce7ff' },
      },
      mentionSuggestionsEntryText: {
        display: 'inline-block',
        marginLeft: '8px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '368px',
        fontSize: '0.9em',
        marginBottom: '0.2em',
      },
    };
  });
